module.exports = "/_next/static/images/cae7ce47d619d6f8d94afdcea97b3ccb-phone-with-app-open-and-card@2x-lg.jpg";